var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sort"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34615 3L1 9.34615L1.89481 10.241L6.71154 5.43058V19.5H7.98077V5.43058L12.7975 10.241L13.6923 9.34615L7.34615 3Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1061 13.9504L17.2894 18.7608V4.69141H16.0201V18.7608L11.2034 13.9504L10.3086 14.8453L16.6547 21.1914L23.0009 14.8453L22.1061 13.9504Z",
    fill: "#757575"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort_icon.08de49f5670ea404585131d0d89bef55.svg";
export { ForwardRef as ReactComponent };